import React from 'react'
import {Box, Divider, Grid, Skeleton, Stack} from '@chakra-ui/react'

export function ProviderInfoCardSkeleton() {
  return (
    <Box bg="white" borderRadius="md" boxShadow="sm">
      <Skeleton borderBottomRadius="none" h={300} />

      <Stack p={4} spacing={4}>
        <Skeleton h={4} w="50%" />

        <Stack>
          <Skeleton h={4} w="full" />
          <Skeleton h={4} w="full" />
          <Skeleton h={4} w="full" />
          <Skeleton h={4} w="full" />
          <Skeleton h={4} w="full" />
          <Skeleton h={4} w="full" />
        </Stack>
      </Stack>

      <Divider borderColor="gray.100" m={0} />

      <Grid gap={4} p={4} templateColumns="2fr 1fr">
        <Skeleton h={4} w="full" />
        <Skeleton h={4} w="full" />
        <Skeleton h={4} w="full" />
      </Grid>
    </Box>
  )
}
